import { LinearGradient } from "expo-linear-gradient";
import { capitalize } from "lodash";

import { WeatherConditionProps } from "@whoosh/design-system/src/components/display/WeatherCondition";
import { WeatherIcon } from "@whoosh/design-system/src/components/icons_v2/weather";
import {
  Box,
  HStack,
  Text,
} from "@whoosh/design-system/src/components/primitive";

export const TimeSlotListWeatherRow = ({
  weatherCondition,
  isInRequest,
}: {
  weatherCondition: WeatherConditionProps | undefined | null;
  isInRequest?: boolean;
}) => {
  const tempUnit = weatherCondition?.measurementSystem === "METRIC" ? "C" : "F";
  const windUnit =
    weatherCondition?.measurementSystem === "METRIC" ? "m/s" : "mph";
  const weatherConditionLabel = weatherCondition?.weatherCategory
    ? `${capitalize(weatherCondition.weatherCategory)},`
    : "";
  const tempInF = weatherCondition?.temperature
    ? `${Math.round(weatherCondition.temperature)}° ${tempUnit},`
    : "";
  const humidity = weatherCondition?.humidityInPercent
    ? `Humidity: ${weatherCondition?.humidityInPercent}%,`
    : "";
  const windSpeed = weatherCondition?.windSpeedInMph
    ? `Wind: ${Math.round(weatherCondition.windSpeedInMph)} ${windUnit}`
    : "";
  return weatherCondition ? (
    <LinearGradient
      colors={["#E1E5E5", "transparent"]}
      start={{ x: 0, y: 0 }}
      end={{ x: 0, y: 1 }}
      style={{
        borderRadius: 16,
        padding: 1.5,
        height: 48,
        width: "100%",
        marginTop: 24,
      }}
    >
      <Box
        width="100%"
        height="100%"
        bg="surface-secondary"
        borderRadius="4"
        alignItems="center"
        justifyContent="center"
      >
        <HStack gap={2}>
          <WeatherIcon weatherCategory={weatherCondition.weatherCategory} />
          <Text variant="mainTiny" color="text-primary">
            {`${weatherConditionLabel} ${tempInF} ${humidity} ${windSpeed}`}
          </Text>
        </HStack>
      </Box>
    </LinearGradient>
  ) : null;
};
